import { render, staticRenderFns } from "./content-item.vue?vue&type=template&id=b4f75bba&"
import script from "./content-item.vue?vue&type=script&lang=js&"
export * from "./content-item.vue?vue&type=script&lang=js&"
import style0 from "./content-item.vue?vue&type=style&index=0&id=b4f75bba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports